/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getApiPublicText } from '../fn/texts/get-api-public-text';
import { GetApiPublicText$Params } from '../fn/texts/get-api-public-text';
import { TextsResponse } from '../models/texts-response';

@Injectable({ providedIn: 'root' })
export class TextsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getApiPublicText()` */
  static readonly GetApiPublicTextPath = '/api/public/{_locale}/texts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiPublicText()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiPublicText$Response(params: GetApiPublicText$Params, context?: HttpContext): Observable<StrictHttpResponse<TextsResponse>> {
    return getApiPublicText(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiPublicText$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiPublicText(params: GetApiPublicText$Params, context?: HttpContext): Observable<TextsResponse> {
    return this.getApiPublicText$Response(params, context).pipe(
      map((r: StrictHttpResponse<TextsResponse>): TextsResponse => r.body)
    );
  }

}
